var map = {
	"./2D/1/Untitled Child in Car, 2024.png": 223,
	"./2D/2/Untitled Woman Crying, 2023. Charcoal and Conté Crayon on SPF (Spruce-Pine-Fir) Wood Panel, 24 x 36 inches.jpg": 325,
	"./2D/2/Untitled Woman, 2023. Charcoal and Conté Crayon on Paper, 18 x 24 inches.jpg": 907,
	"./2D/3/Untitled Woman in the Dark, 2022. Oil Paint on Canvas, 12 x 16 inches.jpg": 485,
	"./2D/3/Untitled Woman in the Window, 2023. Oil Paint on Canvas, 18 x 24 inches.jpg": 593,
	"./2D/3/Untitled Woman wearing Blue, 2023. Oil Paint on Canvas, 12 x 12 inches.jpg": 891,
	"./3D/1/Untitled Sculpture, 2014. Lacquered Grape Vine, 39 x 50 x 6 inches..jpg": 13,
	"./3D/5/Untitled Ceramic Thread Series, 2022. Ceramic and thread, 4.5 x 24 x 8 inches.  (2).jpg": 75,
	"./3D/5/Untitled Ceramic Thread Series, 2022. Ceramic and thread, 4.5 x 24 x 8 inches.  (3).jpg": 112,
	"./3D/5/Untitled Ceramic Thread Series, 2022. Ceramic and thread, 4.5 x 24 x 8 inches.  (4).jpg": 669,
	"./3D/5/Untitled Ceramic Thread Series, 2022. Ceramic and thread, 4.5 x 24 x 8 inches.  (5).jpg": 490,
	"./3D/5/Untitled Ceramic Thread Series, 2022. Ceramic and thread, 4.5 x 24 x 8 inches. .jpg": 540,
	"./3D/5b/Untitled Ceramic Plate Series, 2022. Ceramic and Ink, 12 x 125 x 4 inches (10).jpg": 510,
	"./3D/5b/Untitled Ceramic Plate Series, 2022. Ceramic and Ink, 12 x 125 x 4 inches (2).jpg": 35,
	"./3D/5b/Untitled Ceramic Plate Series, 2022. Ceramic and Ink, 12 x 125 x 4 inches (3).jpg": 160,
	"./3D/5b/Untitled Ceramic Plate Series, 2022. Ceramic and Ink, 12 x 125 x 4 inches (4).jpg": 901,
	"./3D/5b/Untitled Ceramic Plate Series, 2022. Ceramic and Ink, 12 x 125 x 4 inches (5).jpg": 786,
	"./3D/5b/Untitled Ceramic Plate Series, 2022. Ceramic and Ink, 12 x 125 x 4 inches (6).jpg": 655,
	"./3D/5b/Untitled Ceramic Plate Series, 2022. Ceramic and Ink, 12 x 125 x 4 inches (7).jpg": 340,
	"./3D/5b/Untitled Ceramic Plate Series, 2022. Ceramic and Ink, 12 x 125 x 4 inches (8).jpg": 97,
	"./3D/5b/Untitled Ceramic Plate Series, 2022. Ceramic and Ink, 12 x 125 x 4 inches (9).jpg": 590,
	"./3D/5b/Untitled Ceramic Plate Series, 2022. Ceramic and Ink, 12 x 125 x 4 inches.jpg": 716
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 221;